import type { ShellContract } from "@agentnative/shell";

/**
 * Shell contract for console/web. This app runs standalone today (there is
 * no marketplace shell consumer yet), but wrapping the root with
 * ShellAdapter.wrap(...) means it slots into the marketplace shell later
 * without a rewrite -- see ui/ui_prd.md "Deployment Modes". Kept minimal:
 * only metadata + navigation are filled in, no shell services/permissions
 * that have no consumer yet.
 */
export const consoleShellContract: ShellContract = {
  metadata: {
    appId: "agentnative-console",
    name: "Agent Native Console",
    version: "0.1.0",
    description: "Organization self-service and staff admin console for Agent Native.",
    icon: "⚙", // gear glyph, no emoji
    category: "productivity",
  },
  navigation: {
    items: [
      { id: "dashboard", label: "Dashboard", path: "/" },
      { id: "org-settings", label: "Organization", path: "/settings/organization" },
      { id: "members", label: "Members", path: "/settings/members" },
      { id: "billing", label: "Billing", path: "/settings/billing" },
      { id: "licenses", label: "My Licenses", path: "/settings/licenses" },
      { id: "tokens", label: "API Tokens", path: "/settings/tokens" },
      { id: "marketplace", label: "Marketplace", path: "/marketplace" },
      { id: "admin-orgs", label: "Staff: Organizations", path: "/admin/organizations" },
    ],
    defaultRoute: "/",
  },
};
